'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  background: ', ';\n  color: ', ';\n  padding: 0px 12px 0px 12px;\n  height: 32px;\n  width: ', ';\n  border-radius: 2px;\n  box-shadow: none;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n\n  ', ';\n\n  > div[name=\'iconContainer\'] {\n    display: flex;\n    align-items: center;\n\n    ', ';\n  }\n\n  &:hover {\n    filter: brightness(0.9);\n  }\n\n  &:focus {\n    box-shadow: 0 0 4px 0 ', ';\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: default;\n  }\n'], ['\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  background: ', ';\n  color: ', ';\n  padding: 0px 12px 0px 12px;\n  height: 32px;\n  width: ', ';\n  border-radius: 2px;\n  box-shadow: none;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n\n  ', ';\n\n  > div[name=\'iconContainer\'] {\n    display: flex;\n    align-items: center;\n\n    ', ';\n  }\n\n  &:hover {\n    filter: brightness(0.9);\n  }\n\n  &:focus {\n    box-shadow: 0 0 4px 0 ', ';\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: default;\n  }\n']);
var _ButtonBase = require('./ButtonBase');
var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var PrimaryButton = (0, _styledComponents2['default'])(_ButtonBase2['default'])(_templateObject, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  var iconOnly = props.icon && props.text === undefined;
  if (iconOnly) {
    return props.iconSize ? props.iconSize + 'px' : '13px';
  }
  return '13px';
}, function (props) {
  return props.theme.fontWeightRegular;
}, function (props) {
  return props.theme.colorButtonPrimary;
}, function (props) {
  return props.theme.colorBackgroundLight;
}, function (props) {
  return props.width && props.width + 'px';
}, function (props) {
  return props.inline === true ? 'inline-flex' : 'flex';
}, function (props) {
  var iconOnly = props.icon && props.text === undefined;
  if (iconOnly) {
    return {
      height: 'fit-content',
      padding: '6px'
    };
  }
}, function (props) {
  var iconOnly = props.icon && props.text === undefined;
  if (!iconOnly) {
    if (props.iconPosition === 'right') {
      return {
        marginLeft: '4px',
        order: 1
      };
    } else {
      return {
        marginRight: '4px'
      };
    }
  }
}, function (props) {
  return props.theme.colorButtonPrimary;
});
PrimaryButton.displayName = 'PrimaryButton';
exports['default'] = PrimaryButton;